export const SHARE = {
  MODAL_TITLE: 'Share Story',
  MEMBER: 'member',
  MEMBERS: 'members',
  SUCCESS: 'Story shared successfully!',
  SECTION_USERS: 'Share with users',
  SECTION_CIRCLE: 'Share with a circle',
  USERNAME_PLACEHOLDER: '@username',
  ARIA_REMOVE: 'Remove',
  ADD_USER: 'Add another user',
  LOADING_CIRCLES: 'Loading circles...',
  NO_CIRCLES: "You don't have any circles yet.",
  CREATE_CIRCLE: 'Create a circle',
  ERRORS: {
    NO_RECIPIENTS: 'Select a circle or enter at least one username.',
    FAILED: 'Failed to share story.',
  },
  BUTTONS: {
    CANCEL: 'Cancel',
    SHARE: 'Share',
  },
};

export const SHARED_WITH_YOU = {
  TITLE: 'Shared with you',
  EMPTY: 'No stories shared with you yet',
  ERROR: 'Unable to load shared stories',
};

export const SHARED_PAGE = {
  TITLE: 'Shared with you',
  LOADING: 'Loading...',
  ERROR_PREFIX: 'Error loading shared stories: ',
  EMPTY: 'No stories have been shared with you yet.',
  BADGE_CIRCLE: 'Circle',
  BADGE_DIRECT: 'Direct',
};

export const SHARED_META = {
  SHARED_BY: 'Shared by @',
  VIA: ' via ',
  MEMBER: 'member',
  MEMBERS: 'members',
};

export const STORY_ROW = {
  NO_READS: 'No reads yet',
  READ_BY: 'Read by',
  OF: 'of',
  MEMBERS: 'members',
  SHOW: 'show',
  HIDE: 'hide',
};
